export default __webpack_public_path__ + "static/media/log-out.692d003a.svg";